import $ from 'jquery';
import App from './App';
import Tabs from './Tabs';
import 'slick-carousel/slick/slick.min.js';
import Blog from './Blog';

// eslint-disable-next-line import/prefer-default-export
export const TextInit = () => {
  App.run(() => {
    $('.cm__slick-slider').slick({
      infinite: false,
      prevArrow: '<button class="slick-prev"><i class="icon-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="icon-right"></i></button>',
      dots: true,
    });
  }, 'all', '.cm__slick-slider');

  App.run(() => {
    $(document).on('click', '.cm__questions-q', function toggleAnswearTab() {
      const self = $(this);
      const tab = self.next('.cm__questions-a');
      const className = '--expanded';
      if (self.hasClass(className)) {
        self.removeClass(className);
        tab.slideUp();
      } else {
        self.addClass(className);
        tab.slideDown();
      }
    });
  }, 'all', '.cm__questions');

  App.run(() => {
    const yt = (url) => `
      <div class="cm__iframe">
        <iframe
          width="560" 
          height="315" 
          src="${url}" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowfullscreen="">
        </iframe>
      </div>
    `;
    $(document).on('click', '.cm__video', function openYtIframe(e) {
      e.preventDefault();
      const self = $(this);
      const url = self.attr('href');
      const iframe = yt(url);
      self.before(iframe);
    });
  }, 'all', '.cm__video');

  App.run(() => {
    App.vars.cmTabs = new Tabs({
      selector: '.cm__tabs-wrapp',
      destination: '.cm__tabs-dest',
    });
  }, 'all', '.cm__tabs');

  App.run(() => {
    const replaceAllPolishLetters = (text = '') => text.toLowerCase().replace(/ł/g, 'l').normalize('NFKD').replace(/[^\w]/g, '');
    $(document).on('submit', '.cm__search', function searchWordInSection(event) {
      event.preventDefault();
      const self = $(this);
      const { item: itemName, section: sectionName, tag: tagName } = self.data();

      if (!itemName || !sectionName || !tagName) return false;
      const input = self.find('.f-control');
      const filter = replaceAllPolishLetters(input.val());

      $(sectionName).each(function findWordInSection() {
        const section = $(this);
        const items = section.find(itemName);
        const tag = replaceAllPolishLetters(section.find(tagName).text());
        let isEmpty = false;
        items.each(function findWordInSectionItem() {
          const item = $(this);
          const text = replaceAllPolishLetters(item.text());
          if (text.includes(filter) || tag.includes(filter)) {
            item.show();
            isEmpty = true;
          } else {
            item.hide();
          }
        });
        if (isEmpty || tag.includes(filter)) {
          section.show();
        } else {
          section.hide();
        }
      });
      return false;
    });
  }, 'all', '.cm__search');

  App.run(() => {
    const elements = document.querySelectorAll('.cm_articles.--skeleton');
    elements.forEach((element) => {
      const attributes = element.getAttributeNames().filter((el) => el.startsWith('data-'));
      const config = attributes.reduce((acc, current) => {
        const name = current.slice(5); // because data-
        const tmp_value = element.getAttribute(current);
        const value = (tmp_value === 'true' || tmp_value === 'false') ? ((tmp_value === 'true') ? true : false) : tmp_value;
        acc[name] = (name === 'articlestoshow') ? Number(value) : value;
        return acc;
      }, {});
      App.vars.cmBlog = new Blog(config, element);
    });
  }, 'all', '.cm_articles.--skeleton');
};
